import { isEmptyNullOrUndefined } from 'flow/utils';
import { Circle } from 'rc-progress';
import React from 'react';

interface Props {
    successfulEvents: number;
    allEvents: number;
    strokeColor: string;
    trailColor: string;
}

const PercentageWidget = ({
    successfulEvents,
    allEvents,
    strokeColor,
    trailColor,
}: Props) => {
    if (
        isEmptyNullOrUndefined(allEvents) ||
        isEmptyNullOrUndefined(successfulEvents)
    ) {
        return (
            <div className="relative flex">
                <Circle
                    strokeWidth={8}
                    strokeColor={strokeColor}
                    trailWidth={8}
                    trailColor={trailColor}
                />
            </div>
        );
    }

    const percent =
        allEvents !== 0
            ? Math.round((successfulEvents / allEvents) * 100)
            : 100;

    return (
        <div className="relative flex size-24 md:size-28">
            <Circle
                percent={percent}
                strokeWidth={8}
                strokeColor={strokeColor}
                trailWidth={8}
                trailColor={trailColor}
                className="size-full"
            />
            <div className="absolute flex size-full flex-col items-center justify-center">
                <div className="font-bold text-gray-800">{percent + '%'}</div>

                <div className="text-xs text-gray-500">
                    {successfulEvents + '/' + allEvents}
                </div>
            </div>
        </div>
    );
};

export default PercentageWidget;
